import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseNegotiationsApplicableProductsProps<T> = {
  filters?: {
    page?: number;
    search?: string;
    establishment_id?: string;
  };
  mapper?: (data: any) => T,
};

export const useNegotiationsApplicableProducts = <T,>({
  filters: { search, page, establishment_id } = {},
  mapper = Mapper.default<T>(),
}: UseNegotiationsApplicableProductsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    enabled: !!establishment_id,
    queryKey: ['applicableProducts', search, page, establishment_id],
    queryFn: () => {
      return privateAxios.get(`/negotiations/available_products`, {
        params: {
          search,
          page,
          'establishment_company_id': establishment_id,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
